/*=========================================
	++ common.js ++ Ver.1.5.3
	Last update 2019.5.7
==========================================*/
/*
* 2019  5/ 7  *object-fit-images 追加
* 2018 11/20  *ブラウザ判定処理を一新
* 2018 10/25  *jQuery 3系 に対応

*/
//'usestrict';









//============================================
//  npm.im/object-fit-images 3.2.4
//  https://github.com/bfred-it/object-fit-images
//============================================

/*! npm.im/object-fit-images 3.2.4 */
var objectFitImages = (function () {
	'use strict';

	var OFI = 'bfred-it:object-fit-images';
	var propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
	var testImg = typeof Image === 'undefined' ? {
		style: {
			'object-position': 1
		}
	} : new Image();
	var supportsObjectFit = 'object-fit' in testImg.style;
	var supportsObjectPosition = 'object-position' in testImg.style;
	var supportsOFI = 'background-size' in testImg.style;
	var supportsCurrentSrc = typeof testImg.currentSrc === 'string';
	var nativeGetAttribute = testImg.getAttribute;
	var nativeSetAttribute = testImg.setAttribute;
	var autoModeEnabled = false;

	function createPlaceholder(w, h) {
		return ("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E");
	}

	function polyfillCurrentSrc(el) {
		if (el.srcset && !supportsCurrentSrc && window.picturefill) {
			var pf = window.picturefill._;
			// parse srcset with picturefill where currentSrc isn't available
			if (!el[pf.ns] || !el[pf.ns].evaled) {
				// force synchronous srcset parsing
				pf.fillImg(el, {
					reselect: true
				});
			}

			if (!el[pf.ns].curSrc) {
				// force picturefill to parse srcset
				el[pf.ns].supported = false;
				pf.fillImg(el, {
					reselect: true
				});
			}

			// retrieve parsed currentSrc, if any
			el.currentSrc = el[pf.ns].curSrc || el.src;
		}
	}

	function getStyle(el) {
		var style = getComputedStyle(el).fontFamily;
		var parsed;
		var props = {};
		while ((parsed = propRegex.exec(style)) !== null) {
			props[parsed[1]] = parsed[2];
		}
		return props;
	}

	function setPlaceholder(img, width, height) {
		// Default: fill width, no height
		var placeholder = createPlaceholder(width || 1, height || 0);

		// Only set placeholder if it's different
		if (nativeGetAttribute.call(img, 'src') !== placeholder) {
			nativeSetAttribute.call(img, 'src', placeholder);
		}
	}

	function onImageReady(img, callback) {
		// naturalWidth is only available when the image headers are loaded,
		// this loop will poll it every 100ms.
		if (img.naturalWidth) {
			callback(img);
		} else {
			setTimeout(onImageReady, 100, img, callback);
		}
	}

	function fixOne(el) {
		var style = getStyle(el);
		var ofi = el[OFI];
		style['object-fit'] = style['object-fit'] || 'fill'; // default value

		// Avoid running where unnecessary, unless OFI had already done its deed
		if (!ofi.img) {
			// fill is the default behavior so no action is necessary
			if (style['object-fit'] === 'fill') {
				return;
			}

			// Where object-fit is supported and object-position isn't (Safari < 10)
			if (
				!ofi.skipTest && // unless user wants to apply regardless of browser support
				supportsObjectFit && // if browser already supports object-fit
				!style['object-position'] // unless object-position is used
			) {
				return;
			}
		}

		// keep a clone in memory while resetting the original to a blank
		if (!ofi.img) {
			ofi.img = new Image(el.width, el.height);
			ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
			ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;

			// preserve for any future cloneNode calls
			// https://github.com/bfred-it/object-fit-images/issues/53
			nativeSetAttribute.call(el, "data-ofi-src", el.src);
			if (el.srcset) {
				nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
			}

			setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);

			// remove srcset because it overrides src
			if (el.srcset) {
				el.srcset = '';
			}
			try {
				keepSrcUsable(el);
			} catch (err) {
				if (window.console) {
					console.warn('https://bit.ly/ofi-old-browser');
				}
			}
		}

		polyfillCurrentSrc(ofi.img);

		el.style.backgroundImage = "url(\"" + ((ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"')) + "\")";
		el.style.backgroundPosition = style['object-position'] || 'center';
		el.style.backgroundRepeat = 'no-repeat';
		el.style.backgroundOrigin = 'content-box';

		if (/scale-down/.test(style['object-fit'])) {
			onImageReady(ofi.img, function () {
				if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
					el.style.backgroundSize = 'contain';
				} else {
					el.style.backgroundSize = 'auto';
				}
			});
		} else {
			el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
		}

		onImageReady(ofi.img, function (img) {
			setPlaceholder(el, img.naturalWidth, img.naturalHeight);
		});
	}

	function keepSrcUsable(el) {
		var descriptors = {
			get: function get(prop) {
				return el[OFI].img[prop ? prop : 'src'];
			},
			set: function set(value, prop) {
				el[OFI].img[prop ? prop : 'src'] = value;
				nativeSetAttribute.call(el, ("data-ofi-" + prop), value); // preserve for any future cloneNode
				fixOne(el);
				return value;
			}
		};
		Object.defineProperty(el, 'src', descriptors);
		Object.defineProperty(el, 'currentSrc', {
			get: function () {
				return descriptors.get('currentSrc');
			}
		});
		Object.defineProperty(el, 'srcset', {
			get: function () {
				return descriptors.get('srcset');
			},
			set: function (ss) {
				return descriptors.set(ss, 'srcset');
			}
		});
	}

	function hijackAttributes() {
		function getOfiImageMaybe(el, name) {
			return el[OFI] && el[OFI].img && (name === 'src' || name === 'srcset') ? el[OFI].img : el;
		}
		if (!supportsObjectPosition) {
			HTMLImageElement.prototype.getAttribute = function (name) {
				return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
			};

			HTMLImageElement.prototype.setAttribute = function (name, value) {
				return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
			};
		}
	}

	function fix(imgs, opts) {
		var startAutoMode = !autoModeEnabled && !imgs;
		opts = opts || {};
		imgs = imgs || 'img';

		if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
			return false;
		}

		// use imgs as a selector or just select all images
		if (imgs === 'img') {
			imgs = document.getElementsByTagName('img');
		} else if (typeof imgs === 'string') {
			imgs = document.querySelectorAll(imgs);
		} else if (!('length' in imgs)) {
			imgs = [imgs];
		}

		// apply fix to all
		for (var i = 0; i < imgs.length; i++) {
			imgs[i][OFI] = imgs[i][OFI] || {
				skipTest: opts.skipTest
			};
			fixOne(imgs[i]);
		}

		if (startAutoMode) {
			document.body.addEventListener('load', function (e) {
				if (e.target.tagName === 'IMG') {
					fix(e.target, {
						skipTest: opts.skipTest
					});
				}
			}, true);
			autoModeEnabled = true;
			imgs = 'img'; // reset to a generic selector for watchMQ
		}

		// if requested, watch media queries for object-fit change
		if (opts.watchMQ) {
			window.addEventListener('resize', fix.bind(null, imgs, {
				skipTest: opts.skipTest
			}));
		}
	}

	fix.supportsObjectFit = supportsObjectFit;
	fix.supportsObjectPosition = supportsObjectPosition;

	hijackAttributes();

	return fix;

}());

//============================================
//	objectFitImages 設定
//  CSS
//	for ALL -- object-fit: cover;
//	for IE --  font-family: 'object-fit: cover;';
//============================================

$(function () {
	objectFitImages('.idxVisual img');
	objectFitImages('.unit_thumb_box .unit_photo img');
	objectFitImages('.unit_slider_main img');
	objectFitImages('.unit_slider_sub img');
});



/*
 * rwdImageMaps jQuery plugin v1.6
 *
 * Allows image maps to be used in a responsive design by recalculating the area coordinates to match the actual image size on load and window.resize
 *
 * Copyright (c) 2016 Matt Stow
 * https://github.com/stowball/jQuery-rwdImageMaps
 * http://mattstow.com
 * Licensed under the MIT license
 */
;
(function ($) {
	$.fn.rwdImageMaps = function () {
		var $img = this;

		var rwdImageMap = function () {
			$img.each(function () {
				if (typeof ($(this).attr('usemap')) == 'undefined')
					return;

				var that = this,
					$that = $(that);

				// Since WebKit doesn't know the height until after the image has loaded, perform everything in an onload copy
				$('<img />').on('load', function () {
					var attrW = 'width',
						attrH = 'height',
						w = $that.attr(attrW),
						h = $that.attr(attrH);

					if (!w || !h) {
						var temp = new Image();
						temp.src = $that.attr('src');
						if (!w)
							w = temp.width;
						if (!h)
							h = temp.height;
					}

					var wPercent = $that.width() / 100,
						hPercent = $that.height() / 100,
						map = $that.attr('usemap').replace('#', ''),
						c = 'coords';

					$('map[name="' + map + '"]').find('area').each(function () {
						var $this = $(this);
						if (!$this.data(c))
							$this.data(c, $this.attr(c));

						var coords = $this.data(c).split(','),
							coordsPercent = new Array(coords.length);

						for (var i = 0; i < coordsPercent.length; ++i) {
							if (i % 2 === 0)
								coordsPercent[i] = parseInt(((coords[i] / w) * 100) * wPercent);
							else
								coordsPercent[i] = parseInt(((coords[i] / h) * 100) * hPercent);
						}
						$this.attr(c, coordsPercent.toString());
					});
				}).attr('src', $that.attr('src'));
			});
		};
		$(window).resize(rwdImageMap).trigger('resize');

		return this;
	};
})(jQuery);



$('img[usemap]').rwdImageMaps();


//============================================
//	Detecting Browser & Device Ver.1.4.2
//============================================

//++++++++++++ モバイル/タブレット/ブラウザ判定処理 ++++++++++++

//ブラウザ/デバイス 種別
var isMobile = false,
	isTablet = false,
	isRetina = false,
	isMobileTablet = false,
	isAndroid = false;

//モバイル　タブレット　判定
//https://w3g.jp/blog/js_browser_sniffing2015
var _ua = (function (u) {
	return {
		Tablet: (u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1) ||
			u.indexOf("ipad") != -1 ||
			(u.indexOf("android") != -1 && u.indexOf("mobile") == -1) ||
			(u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1) ||
			u.indexOf("kindle") != -1 ||
			u.indexOf("silk") != -1 ||
			u.indexOf("playbook") != -1,
		Mobile: (u.indexOf("windows") != -1 && u.indexOf("phone") != -1) ||
			u.indexOf("iphone") != -1 ||
			u.indexOf("ipod") != -1 ||
			(u.indexOf("android") != -1 && u.indexOf("mobile") != -1) ||
			(u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1) |
			u.indexOf("blackberry") != -1
	};
})(window.navigator.userAgent.toLowerCase());

//モバイル
if (_ua.Mobile) {
	isMobile = true;
	isMobileTablet = true;
}
//タブレット
if (_ua.Tablet) {
	isTablet = true;
	isMobileTablet = true;
}

//Retina Display 判定
if (window.retina || window.devicePixelRatio > 1) {
	isRetina = true;
}

//Android 判定
if (/android[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
	isAndroid = true;
}




//============================================
//	デバイス　ブラウザ別の処理
//============================================

//++++++++++++ モバイル/タブレット クラス追加 ++++++++++++

$(function () {
	if (isMobile) {
		//HTMLにclass isMobileを追加
		$('html').addClass('isMobile');
		$('html').addClass('isMobileTablet');
	} else if (isTablet) {
		//HTMLにclass isTabletを追加
		$('html').addClass('isTablet');
		$('html').addClass('isMobileTablet');
	}
	//Retina Display isRetina クラス追加
	if (isRetina) {
		$('html').addClass('isRetina');
	}
});





//============================================
//	汎用スクリプト 
//============================================


//++++++ Copyright ++++++
// Copyright <span class="copyYear">&copy;</span>

$(function () {
	var date = new Date();
	var copyYear = date.getFullYear();
	copyYear = "&copy; " + "1995-" + copyYear;
	$('.copyYear').html(copyYear);
});





//++++++ Page Anc Scroll ++++++
/*$(function () {
	$(document).on("click", "a[href*=#],area[href*=#]", function () {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
			location.hostname == this.hostname) {
			var $target = $(this.hash);
			$target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');
			if ($target.length) {
				var targetOffset = $target.offset().top - 20;
				$('html,body').animate({
					scrollTop: targetOffset
				}, 800);
				return false;
			}
		}
	});
});*/


//============================================
//	アンカーリンク　スクロール
//============================================

$(function () {

	var TABLET_WIDTH = 768;
	//ウィンドウ幅
	var window_width = window.innerWidth;

	var nav_height = 80;
	if (window_width >= TABLET_WIDTH) {
		nav_height = 80;
	}


	var target_parm = '';
	var match = location.search.match(/target=(.*?)(&|$)/);
	if (match) {
		target_parm = decodeURIComponent(match[1]);
		target_parm = '#' + target_parm;
	}
	if (target_parm.length) {
		setTimeout(function () {
			var targetOffset = $(target_parm).offset().top - nav_height;
			$('html,body').animate({
				scrollTop: targetOffset
			}, 800);
			return false;
		}, 500);
	}

});

//============================================
//	サイド　ボタン調整
//============================================
$(function () {
	function side_btn_size() {
		var window_height = $(window).height();
		window_height = Number(window_height);
		//PC 最小画面
		var PC_SMALL_WIDTH = 1200;
		//デバイスのウィンドウ幅 取得
		var window_width = window.innerWidth;

		if (window_width >= PC_SMALL_WIDTH) {
			$('.side_btn').css('height', window_height + 'px');
		} else {
			$('.side_btn').css('height', '60px');
		}
	}

	side_btn_size();

	$(window).resize(function (event) {
		side_btn_size();
	});
});

//============================================
//	モバイル　ナビ
//============================================




$(function () {

	$('.js-mobile_navi').on('click', function () {

		if ($('.js-mobile_navi').hasClass('navi_active')) {
			//$('.mobile_navi').fadeOut('fast');
			$('.mobile_navi').addClass('navi_hide');
			$('.mobile_navi_bg').addClass('navi_bg_hide');
			$('body').removeClass('non_scroll');
			$('html').removeClass('non_scroll');
			$('.js-mobile_navi').removeClass('navi_active');
			$('.sp_header_login .acount_face').removeClass('acount_face_hide');
		} else {
			//	$('.mobile_navi').fadeIn('fast');
			$('.mobile_navi').addClass('mobile_navi_slide');
			$('.mobile_navi').removeClass('navi_hide');
			$('.mobile_navi_bg').removeClass('navi_bg_hide');
			$('body').addClass('non_scroll');
			$('html').addClass('non_scroll');
			$('.js-mobile_navi').addClass('navi_active');
			$('.sp_header_login .acount_face').addClass('acount_face_hide');

			/*var window_height = $(window).height();
			window_height = Number(window_height);

			$('.mobile_navi').css('height', window_height + 'px');
			$('.mobile_navi_bg').css('height', window_height + 'px');*/
		}



	});

	/*var window_height = $(window).height();
	window_height = Number(window_height);

	$('.mobile_navi').css('height', window_height + 'px');

	$(window).resize(function (event) {
		var window_height = $(window).height();
		window_height = Number(window_height);
		$('.mobile_navi').css('height', window_height + 'px');
	});

	$('.mn_mid-category').click(function () {
		$('.mn_category').fadeToggle();
		if ($(this).hasClass('icon_to_close')) {
			$(this).removeClass('icon_to_close');
		} else {
			$(this).addClass('icon_to_close');
		}

	});
	$('.mn_mid-info').click(function () {
		$('.mn_info').fadeToggle();
		if ($(this).hasClass('icon_to_close')) {
			$(this).removeClass('icon_to_close');
		} else {
			$(this).addClass('icon_to_close');
		}

	});*/


});





//============================================
//	グローバルナビ　現在地
//============================================

$(function () {

	//URLを取得
	var my_path = location.pathname;


	//カテゴリごとの変数
	var is_home, is_nav1, is_nav2, is_nav3, is_nav4, is_nav5, is_nav6, is_nav7 = false;

	//@@@@@@ カテゴリごとのURL規則 @@@@@

	//*** nav1 ***/
	var regex_nav1 = /^\/concept\//i;

	//*** nav2***/
	var regex_nav2 = /^\/interview\//i;

	//*** nav3 ***/
	var regex_nav3 = /^\/how\//i;

	//*** nav4 ***/
	var regex_nav4 = /^\/works\//i;

	//*** nav5 ***/
	var regex_nav5 = /^\/help\//i;


	//*** HOME ***/
	//var regex_home = ($('body').attr('id') == 'root');
	var regex_home = ($('body').hasClass('Index'));


	//@@@@@@ 条件をテスト @@@@@@

	if (my_path.match(regex_nav1)) {
		is_nav1 = true;
	} else if (my_path.match(regex_nav2)) {
		is_nav2 = true;
	} else if (my_path.match(regex_nav3)) {
		is_nav3 = true;
	} else if (my_path.match(regex_nav4)) {
		is_nav4 = true;
	} else if (my_path.match(regex_nav5)) {
		is_nav5 = true;
	} else if (regex_home) {
		is_home = true;
	}


	//@@@@@@ 条件にあったら　.activeを追加　@@@@@@

	//クラス activeを追加
	if (is_home) {
		$('.gnav00').addClass('active');
	} else if (is_nav1) {
		$('.gnav01').addClass('active');
	} else if (is_nav2) {
		$('.gnav02').addClass('active');
	} else if (is_nav3) {
		$('.gnav03').addClass('active');
	} else if (is_nav4) {
		$('.gnav04').addClass('active');
	} else if (is_nav5) {
		$('.gnav05').addClass('active');
	}


});



//+++++++ MIGORO +++++++++

$(function () {

	$('.migoro_list_bar').removeClass('active');
	$('.migoro_list_bar').eq(0).addClass('active');
	$('.migoro_list_content').eq(0).show();

	//if (isMobile) {

	$('.migoro_list_bar').on('click', function () {
		$('.migoro_list_bar').not(this).removeClass('active');
		$(this).toggleClass('active');
		//$(this).addClass('active');
		$(this).parent('.migoro_list_box').find('.migoro_list_content').fadeToggle('fast');
		$('.migoro_list_bar').not(this).parent().find('.migoro_list_content').fadeOut('fast');
	})


	/*} else {
		$('.migoro_list_content').eq(0).show();
		$('.migoro_list_bar').on('click', function () {
			$('.migoro_list_bar').removeClass('active');
			$(this).addClass('active');
			$('.migoro_list_content').fadeOut('fast');
			$(this).parent().find('.migoro_list_content').fadeIn('fast');
		})

	}*/


});


//============================================
//	高さ調整
//============================================
$(function () {

	var picup_height = new Array();
	var spot_height = new Array();
	var event_height = new Array();

	if ($('body').hasClass('Index')) {

		$(".picup_box").each(function (idx) {
			//高さを追加					   
			picup_height[idx] = $(this).height();
		});

		var maxH = Math.max.apply(null, picup_height);

		$(".picup_box").css({
			"height": maxH + "px"
		});

		$(".spot_idx_box").each(function (idx) {
			//高さを追加					   
			spot_height[idx] = $(this).height();
		});

		var maxH = Math.max.apply(null, spot_height);

		$(".spot_idx_box").css({
			"height": maxH + "px"
		});


		$(".event_idx_box").each(function (idx) {
			//高さを追加					   
			event_height[idx] = $(this).height();
		});

		var maxH = Math.max.apply(null, event_height);

		$(".event_idx_box").css({
			"height": maxH + "px"
		});


	}


});


//============================================
//	unit タブ切り替え
//============================================

$(function () {

	$('.tab_txt').on('click', function () {
		var target = $(this).attr('data-target');
		$(this).parents('.unit_tab').find('.tab_img').removeClass('tab_active');
		$(this).parents('.unit_tab').find('.tab_txt').removeClass('tab_active');
		$(this).parents('.unit_tab').find('.tab_caption').removeClass('tab_active');
		$(this).parents('.unit_tab').find(target).addClass('tab_active');
		$(this).addClass('tab_active');


	});


});



//============================================
//	ページ内　アンカーナビ　リンク
//============================================
$(function () {
	//ページ内アンカーは　囲みのDIVに class js-anc-navi 追加
	//  a タグは通常アンカー　<a href="#anc">リンク</a>

	//モバイル判定
	var TABLET_WIDTH = 768;
	//ウィンドウ幅
	var window_width = window.innerWidth;

	//++++ 固定ナビの高さ分ずらす設定  +++
	//モバイル
	var nav_height = 80;
	if (window_width >= TABLET_WIDTH) {
		//PC
		nav_height = 100;
	}

	//aタグクリックで発火
	$('.js-anc-navi a').on('click', function () {

		//a タグの href 取得
		var anc_href = $(this).attr('href');

		//初期ページローディングの遅れ対策
		setTimeout(function () {
			var targetOffset = $(anc_href).offset().top - nav_height;
			$('html,body').animate({
				scrollTop: targetOffset
			}, 800);

			//アンカーズレ　防止　もう一回実行
			setTimeout(function () {
				var targetOffset = $(anc_href).offset().top - nav_height;
				$('html,body').animate({
					scrollTop: targetOffset
				}, 100);
				return false;

			}, 800);

		}, 400);
		//リンクをたどらせない
		return false;
	});
});

//TOPページマージン調整

$(function () {

	$('.idx_picup').parents('.local_Container_inner').addClass('cont_padding_idx_picup_news');
	$('.idx_picup_slider').parents('.local_Container_inner').addClass('cont_padding_idx_picup_slider');

});